import { render, staticRenderFns } from "./UserManagementList.vue?vue&type=template&id=5b086519&scoped=true"
import script from "./UserManagementList.vue?vue&type=script&lang=js"
export * from "./UserManagementList.vue?vue&type=script&lang=js"
import style0 from "./UserManagementList.vue?vue&type=style&index=0&id=5b086519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b086519",
  null
  
)

export default component.exports